import { render, staticRenderFns } from "./ApplicationDocumentsReceived.vue?vue&type=template&id=760ffc04&"
import script from "./ApplicationDocumentsReceived.vue?vue&type=script&lang=js&"
export * from "./ApplicationDocumentsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports